<template>
  <div class="bulid-detail-page">
    <div class="content" >
        <div  id="content"></div>
<!--      <div class="detail-name">{{ detail.title }}</div>-->
<!--      <img class="detail-img" :src="detail.url" alt="" />-->


<!--      <div class="detail-introduce">{{ detail.introduce }}</div>-->
<!--      <div-->
<!--        class="detail-content"-->
<!--        v-for="(item, contentIndex) in detail.content"-->
<!--        :key="contentIndex"-->
<!--      >-->
<!--        {{ item }}-->
<!--      </div>-->
<!--      <img class="detail-advantageImg" :src="detail.advantageImg" alt="" />-->
<!--      <div class="detail-introduce">{{ detail.advantage }}</div>-->
<!--      <div-->
<!--        class="detail-feature"-->
<!--        v-for="(item, featureIndex) in detail.feature"-->
<!--        :key="`detail-feature-${featureIndex}`"-->
<!--      >-->
<!--        <div class="featureTitle">{{ item.featureTitle }}</div>-->
<!--        <div-->
<!--          class="featureDetail"-->
<!--          v-for="(featureDetailItem, featureDetailIndex) in item.featureDetail"-->
<!--          :key="featureDetailIndex"-->
<!--        >-->
<!--          {{ featureDetailItem }}-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="detail-introduce">{{ detail.example }}</div>-->
<!--      <div-->
<!--        v-for="(exampleItem, exampleIndex) in detail.exampleList"-->
<!--        :key="`detail-introduce-${exampleIndex}`"-->
<!--      >-->
<!--      <div class="featureTitle">{{exampleItem.exampleTitle}}</div>-->
<!--      <div  class="featureDetail">{{exampleItem.exampleContent}}</div>-->
<!--      </div>-->
<!--      <img class="detail-advantageImg" :src="detail.featureDetailImg" alt="" />-->
      <div class="data-source">*数据来源于博智林实验室</div>
    </div>
  </div>

</template>

<script>

export default {
  name: "new-bulid-detail",
  data() {
    return {
        detail: {},
    };
  },
  created() {
     this.initData();
  },
    methods:{
        async initData() {
            const id = this.$route.query.id;
            console.log("id", id);


            let contents = await this.$getContents(this.$channels.prefabricated);
            let list = [];
            await contents.filter(item => item.id == id).forEach(
                item => {
                    list.push({
                        id: item.id,
                        url: process.env.VUE_APP_BASE_API + item.imageUrl,
                        title: item.title,
                        content: item.summary,
                        detail: item.body.replaceAll("/upload/images",process.env.VUE_APP_BASE_API+"/upload/images"),

                    })
                }
            );

            console.log("list", list);
            this.detail = list[0];

            console.log("detail", this.detail);

            await this.$wrapDiv(this.detail.detail);
        }
    }

};
</script>

<style scoped>
.content {
  padding: 100px 48px 39px 48px;
}

.detail-img {
  width: 100%;
}
.detail-advantageImg {
  width: 100%;
  margin-top: 64px;
}
.data-source{
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #999999;
    margin-bottom: 100px;
    margin-top: 64px;
  }
.detail-introduce {
  margin-top: 64px;
  margin-bottom: 36px;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 600;
  line-height: 50px;
}
.detail-name {
  height: 67px;
  font-size: 48px;
  font-weight: bold;
  color: #333333;
  line-height: 67px;
  margin-bottom: 38px;
  margin-top: 64px;
}
.detail-content {
  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 50px;
}
.featureTitle {
  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  line-height: 40px;
  margin-top: 36px;
}
.featureDetail {
  font-size: 28px;
  font-family: Menlo, Menlo-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 50px;
}
</style>
